module.exports = __webpack_public_path__ + "static/media/Group 11488.0f41d9f6.png";